import React, { useRef } from 'react';
import Admin from '../admin';
import ErrorBoundary from 'react-error-boundary';
import ErrorFallback from '../ErrorFallback';
import FlowEditor from '../flow/flow-editor';
import PageEditorContainer from '../page/page-editor-container';
import AdminSidebar from '../sidebars/AdminSidebar';
import FlowSidebar from '../sidebars/FlowSidebar';
import PageSidebar from '../sidebars/PageSidebar';
import Tabs from './Tabs';
import useTabRouting from '../../utils/useTabRouting';

import { connect } from 'react-redux';
import { addNotification } from '../../actions/reduxActions/notification';
import { notify } from '../../utils/errors';

import '../../../css/tabs.less';

const TabContent = ({ adminTenantId, editors, authenticationToken, addNotification: onError, role }) => {

    useTabRouting(adminTenantId, authenticationToken, editors, onError, role);

    const sideBarRef = useRef(null);

    const getSidebars = (editor) => {
        switch (editor.type) {
        case 'organization':
        case 'tenant':
        case 'userNotifications':
        case 'userSettings':
        case 'data-stores':
        case 'flows':
        case 'pages':
        case 'values':
        case 'services':
        case 'types':
        case 'assets':
        case 'flowlibrary':
        case 'build':
        case 'import-export':
        case 'players':
        case 'macros':
        case 'dashboard':
        case 'audit':
            return <AdminSidebar isActive={editor.isActive} editorType={editor.type} />;
        case 'flow':
            return <FlowSidebar flowId={editor.flowId} isActive={editor.isActive} sideBarRef={sideBarRef} />;
        case 'new_page':
        case 'page':
            return <PageSidebar pageId={editor.pageId} isActive={editor.isActive} />;
        default:
            return null;
        }
    };

    const getEditorComponent = (editor) => {
        let isNew = false;
        if (editor) {
            switch (editor.type) {
            case 'flows':
            case 'pages':
            case 'values':
            case 'services':
            case 'types':
            case 'assets':
            case 'flowlibrary':
            case 'build':
            case 'import-export':
            case 'players':
            case 'macros':
            case 'dashboard':
            case 'organization':
            case 'tenant':
            case 'data-stores':
            case 'userNotifications':
            case 'userSettings':
            case 'audit':
                return <Admin adminTenantId={adminTenantId} isActive={editor.isActive} view={editor.type} key={editor.id} />;
            case 'flow':
                return (
                    <ErrorBoundary
                        FallbackComponent={ErrorFallback}
                        onError={(error, info) => {
                            notify({
                                error,
                                params: {
                                    flowId: editor.flowId,
                                    pageId: editor.pageId,
                                    editorId: editor.id,
                                    componentStack: info,
                                },
                            });
                        }}
                    >
                        <FlowEditor
                            key={editor.flowId}
                            id={editor.id}
                            flowId={editor.flowId}
                            isActive={editor.isActive}
                            sideBarRef={sideBarRef}
                        />
                    </ErrorBoundary>
                );
            case 'new_page':
                isNew = true;
                // falls through
            case 'page':
                return (
                    <PageEditorContainer
                        command={editor.command}
                        key={editor.pageId}
                        id={editor.id}
                        flowId={editor.flowId}
                        pageId={editor.pageId}
                        isActive={editor.isActive}
                        mapElement={editor.mapElement}
                        adminTenantId={adminTenantId}
                        isNew={isNew}
                    />
                );
            default:
                return null;
            }
        }

        return null;
    };

    return (
        <div className="tab-outer">
            {editors.map(getSidebars)}
            <div className="tabs">
                <Tabs editors={editors} />
                <div className="tab-content-wrapper">
                    {editors.map(getEditorComponent)}
                </div>
            </div>
        </div>
    );
};

export default connect(({ currentUser }) => {
    return { role: currentUser.roleName };
}, { addNotification })(TabContent);
